var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/icons.svg#collapse';
                    var viewUrl = 'svg/icons.svg#view-collapse';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };